module.exports = __webpack_public_path__ + "static/media/Logo-new-2021.17592057.svg";